import React from 'react';
import { Table, Input, InputNumber, Popconfirm, Form, Typography, message, ConfigProvider } from 'antd';
import { ProvinceSelect, CitySelect } from './areaSelect';
import { useDispatch, useSelector } from "react-redux";
import { setSelectedProvince, setSelectedCity } from '../../../actions/areaActions';
import { toTabColName, toDbColName } from './areaHelper'
import axios from '../../../utils/AxiosUtil';
import { axiosPostAndHint } from '../../../components/reqAndHint'
import AsyncSwitch from '../../../components/AsycSwitch'

import zhCN from 'antd/es/locale/zh_CN';

const { useState, useEffect } = React;
/**
 * 可编辑表格
 * @param props{
 *    columns：表头 参见antd table组件
 *    dataSource：每一行的数据 参见antd table组件
 * }
 */


const EditableCell = ({
    editing,
    dataIndex,
    title,
    rules,
    record,
    index,
    children,
    ...restProps
}) => {
    // const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    const areaEdit = useSelector(state => state.areaEdit);
    const dispatch = useDispatch();

    const { selectedProvince, selectedCity } = areaEdit;

    let inputNode = (<Form.Item
        name={dataIndex}
        style={{
            margin: 0,
        }}
        rules={rules ? [...rules] : null}
    >
        <Input />
    </Form.Item>);
    // <Input />;
    if (toDbColName(dataIndex) == 'province') {

        inputNode = <ProvinceSelect
            defaultProvince={selectedProvince}
            handleProvinceChange={(value) => {
                // console.log('provinceslct change:', value);
                dispatch(setSelectedProvince(value));
                dispatch(setSelectedCity(''));
            }} />
    } else if (toDbColName(dataIndex) == 'city') {
        inputNode = (
            <CitySelect
                defaultCity={selectedCity}
                selectedProvince={areaEdit.selectedProvince}
                handleCityChange={(value) => { dispatch(setSelectedCity(value)); }} />
        );
    }


    return (
        <td {...restProps}>
            {editing ? (
                inputNode
            ) : (
                    children
                )}
        </td>
    );
};

const EditableTable = (props) => {
    let originData = props.dataSource;

    // console.log('originData:', originData);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const areaEdit = useSelector(state => state.areaEdit);
    const { selectedProvince, selectedCity } = areaEdit;

    //需要编辑的record的key
    const [editingKey, setEditingKey] = useState('');

    useEffect(() => {
        setData([...originData])
    }, [props])

    //暂存正在编辑的行
    const isEditing = (record) => record.key === editingKey;

    //点击编辑按钮
    const edit = (record) => {
        // console.log("on edit:", record);
        form.setFieldsValue({
            ...record,
        });

        //定位选中的省和市
        dispatch(setSelectedProvince(record[toTabColName('province')]));
        dispatch(setSelectedCity(record[toTabColName('city')]));

        //record的key字段,将该行定位成编辑状态
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();

            let otherInfo = {
                [toTabColName('province')]: selectedProvince,
                [toTabColName('city')]: selectedCity,
                [toTabColName('aid')]: editingKey
            }
            let newRow = { ...row, ...otherInfo };//补全 ：省、市、id
            let newDbRow = {};
            Object.keys(newRow).forEach((th) => {
                newDbRow[toDbColName(th)] = newRow[th];
            })
            // console.log("****newDbRow:", newDbRow);
            axiosPostAndHint('/area/update', newDbRow,
                () => {
                    const newData = [...data];
                    // console.log("etable newData:", newData);
                    //查找在编辑的那一行
                    const index = newData.findIndex((item) => key === item.key);

                    //有则更新，无则新增
                    if (index > -1) {
                        const item = newData[index];
                        newData.splice(index, 1, { ...item, ...newRow });
                        setData(newData);
                        setEditingKey('');
                    } else {
                        newData.push(row);
                        setData(newData);
                        setEditingKey('');
                    }
                },
                () => {
                    setEditingKey('');
                });
            // console.log("***newRow:", newRow);
            //编辑后表格的所有数据

        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };


    let columns = [...props.columns];

    // 地区编辑功能不启用
    // columns.push({
    //     title: '操作',
    //     dataIndex: 'operation',
    //     render: (_, record) => {
    //         const editable = isEditing(record);
    //         return editable ? (
    //             <span>
    //                 <Typography.Link
    //                     onClick={() => save(record.key)}
    //                     style={{
    //                         marginRight: 8,
    //                     }}
    //                 >
    //                     保存
    //                 </Typography.Link>
    //                 <Popconfirm title="确定撤销更改?" onConfirm={cancel}>
    //                     <a>撤销</a>
    //                 </Popconfirm>
    //             </span>
    //         ) : (
    //             <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
    //                 编辑
    //             </Typography.Link>
    //         );
    //     },
    // },)

    //状态用开关组件渲染
    columns[5].render = (text, record, index) => {
        let checked = record['状态'] == 'on';
        let rcd = record;

        //和组件在同一上下文
        function handleSwitchClick(checked, record) {
            return new Promise((resolve, reject) => {
                axios.post('/fund/area/updateStatus', { aid: record['key'], areaStatus: checked ? "on" : "off" })
                    .then((data) => {
                        // console.log('*********axios data:', data);
                        record['状态'] = checked ? "on" : "off";
                        message.destroy();
                        message.info("更新地区状态成功");
                        resolve(checked);
                    }).catch(e => {
                        //组件应及时恢复原状态,和成功相反，逆向操作
                        //
                        // console.log('*********axios e:', e, e.response.data);
                        record['状态'] = !checked ? "on" : "off"; "on";
                        message.destroy();
                        message.error("更新地区状态失败：" + e ?.response ?.data ?.msg);
                        reject(!checked);
                    });
            })
        }

        return (<div>
            <AsyncSwitch checked={checked} handleClick={
                (checked) => handleSwitchClick(checked, rcd)
            } />
        </div>);
    }


    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            // console.log(col.title, " not editable")
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,//每个单元格对应的行record
                rules: col.rules,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });


    return (
        <ConfigProvider locale={zhCN}>
            <Form form={form}
                component={false}
            >
                <Table
                    sticky
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        onChange: cancel,
                        showQuickJumper: true,
                        pageSizeOptions: [10, 20, 50, 100, 1000],
                    }}
                    rowKey={'序号'}
                />
            </Form>
        </ConfigProvider>
    );
};

export default EditableTable;
